import React from "react";
import {layoutStyles} from '../../assets/jss/layoutStyles'

export default ({children=null, ...props}) => {
  return (
    <div className={layoutStyles().page} {...props}>
      {children}
    </div>
  );
}